import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: () => (
    <div className="py-10">
      <h1 className="text-[28px] leading-tight font-semibold tracking-[-0.02em]">Not found</h1>
      <p className="mt-1.5 text-ink-2">
        This page does not exist.{' '}
        <Link to="/cases" className="text-accent-ink underline underline-offset-2">
          Back to cases
        </Link>
      </p>
    </div>
  ),
});
